module.exports = __webpack_public_path__ + "assets/img/hjjcz.856e3b0a.png";